import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
// import VuePhoneNumberInput from 'vue-phone-number-input';
import router from './router'
import store from './store'
import i18n from './i18n'
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  VueTelInput,
  // VuePhoneNumberInput,
  render: h => h(App)
}).$mount('#app')
